export default __webpack_public_path__ + "media/zurb/img/services/services/emerging-tech-img-276c7434de530160c8b720d80de77681.png";